module.exports = __webpack_public_path__ + "static/contactores_2-fa347c5aa2fabd03ec2f0b3e69b52994.png";